import React, { useEffect, useMemo, useState } from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import { PeriodSelector } from "@/components/PeriodSelector/PeriodSelector";
import { TariffSelector } from "@/components/TariffSelector/TariffSelector";
import { GoalsFunnel } from "@/components/GoalsFunnel/GoalsFunnel";
import { EarningsHero } from "@/components/EarningsHero/EarningsHero";
import { AllTimeTotals } from "@/components/AllTimeTotals/AllTimeTotals";
import { RegistrationsChart } from "@/components/RegistrationsChart/RegistrationsChart";
import { StatisticsSkeleton } from "@/components/StatisticsSkeleton/StatisticsSkeleton";
import {
  formatApiDate,
  getPresetRange,
  startOfDay,
} from "@/components/PeriodSelector/periodDates";
import { getDashboardData } from "@/api/base";
import { useUserInfoStore } from "@/store/userInfoStore";
import { useStatisticsPeriodStore } from "@/store/statisticsPeriodStore";
import { useDashboardStore } from "@/store/dashboardStore";
import { useStatisticsTariffStore } from "@/store/statisticsTariffStore";

// TODO: заменить на дату первого реферала из API статистики
const ALL_TIME_START = new Date(2024, 0, 1);

export const StatisticsSection = () => {
  const yandexId = useUserInfoStore((s) => s.yandexId);
  const dashboardInfo = useDashboardStore((s) => s.dashboardInfo);
  const setDashboardInfo = useDashboardStore((s) => s.setDashboardInfo);
  const selectedTariffs = useStatisticsTariffStore((s) => s.selectedTariffs);

  const [dashboardInfoLoading, setDashboardInfoLoading] = useState<boolean>(
    true
  );

  const preset = useStatisticsPeriodStore((s) => s.preset);
  const customRange = useStatisticsPeriodStore((s) => s.customRange);
  const mode = useStatisticsPeriodStore((s) => s.mode);

  const today = useMemo(() => startOfDay(new Date()), []);

  // свой период из календаря важнее пресета; «Всё время» без даты
  // первого реферала отдаёт null — берём заведомо ранний старт
  const range = useMemo(
    () =>
      customRange ??
      getPresetRange(preset, today) ?? { from: ALL_TIME_START, to: today },
    [customRange, preset, today]
  );

  const loadData = async () => {
    setDashboardInfoLoading(true);

    try {
      const res = await getDashboardData(
        yandexId,
        formatApiDate(range.from),
        formatApiDate(range.to),
        mode,
        selectedTariffs
      );
      setDashboardInfo(res);
      setDashboardInfoLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadData();
  }, [yandexId, mode, range, selectedTariffs]);

  if (dashboardInfoLoading || !dashboardInfo) return <StatisticsSkeleton />;

  return (
    <FlexColumn gap={20}>
      <PeriodSelector />
      <TariffSelector />

      <EarningsHero />
      <GoalsFunnel />
      <AllTimeTotals />
      <RegistrationsChart />
    </FlexColumn>
  );
};
